// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Particles = require("../../../uikit/reason/Styles/Particles.bs.js");
let MediaQuery = require("../../../reason/common/Media/MediaQuery.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let QueryParamUtils = require("../../common/QueryParamUtils.bs.js");
let PropertiesSearchMapURL = require("./PropertiesSearchMapURL.bs.js");

function getDefaultState() {
  return {
    rentalMode: false,
    sortOrder: "RECENTLY_BROADCAST",
    active: true,
    withdrawnOrExpired: false,
    underContract: false,
    soldOrRented: false,
    view: MediaQuery.matches({
      TAG: "MinWidth",
      _0: Particles.Breakpoint.md
    }) ? "Map" : "List",
    grouping: true
  };
}

function hasAreaSelectionChanged(previous, next) {
  let normalizedAreaIds = params => QueryParamUtils.sortAndDeduplicate(Stdlib_Option.getOr(params.areaIds, []), value => value);
  return !Stdlib_Array.equal(normalizedAreaIds(previous), normalizedAreaIds(next), (left, right) => left === right);
}

function toParams(p) {
  let defaultState = getDefaultState();
  let rentalMode = Stdlib_Option.getOr(p.rentalMode, defaultState.rentalMode);
  let active = Stdlib_Option.getOr(p.active, defaultState.active);
  return {
    after: p.after,
    before: p.before,
    rentalMode: rentalMode,
    sortOrder: Stdlib_Option.getOr(p.sortOrder, defaultState.sortOrder),
    areaIds: p.areaIds,
    maxBeds: p.maxBeds,
    maxPrice: p.maxPrice,
    minBeds: p.minBeds,
    minPrice: p.minPrice,
    forSalePropertyTypes: p.forSalePropertyTypes,
    rentalPropertyTypes: p.rentalPropertyTypes,
    keywords: p.keywords,
    offMlsOnly: p.offMlsOnly,
    active: active,
    withdrawnOrExpired: Stdlib_Option.getOr(p.withdrawnOrExpired, defaultState.withdrawnOrExpired),
    underContract: Stdlib_Option.getOr(p.underContract, defaultState.underContract),
    soldOrRented: Stdlib_Option.getOr(p.soldOrRented, defaultState.soldOrRented),
    view: Stdlib_Option.getOr(p.view, defaultState.view),
    grouping: Stdlib_Option.getOr(p.grouping, defaultState.grouping),
    mapViewport: p.mapViewport
  };
}

function fromUrl(params) {
  let rentalMode = QueryParamUtils.bool(params, "rentalMode");
  let sortOrder = Stdlib_Option.flatMap(QueryParamUtils.string(params, "sortOrder"), sortOrder => {
    switch (sortOrder) {
      case "RECENTLY_BROADCAST" :
        return "RECENTLY_BROADCAST";
      case "RECENTLY_UPDATED" :
        return "RECENTLY_UPDATED";
      default:
        return;
    }
  });
  let areaIds = QueryParamUtils.stringArrNonEmpty(params, "areaIds");
  let maxBeds = QueryParamUtils.int(params, "maxBeds");
  let minBeds = QueryParamUtils.int(params, "minBeds");
  let maxPrice = QueryParamUtils.int(params, "maxPrice");
  let minPrice = QueryParamUtils.int(params, "minPrice");
  let forSalePropertyTypes = Stdlib_Array.filterMap(params.getAll("forSalePropertyTypes"), v => {
    switch (v) {
      case "CONDO" :
        return "CONDO";
      case "LOT" :
        return "LOT";
      case "MULTI_UNIT" :
        return "MULTI_UNIT";
      case "SINGLE_FAMILY" :
        return "SINGLE_FAMILY";
      default:
        return;
    }
  });
  let forSalePropertyTypes$1 = forSalePropertyTypes.length !== 0 ? forSalePropertyTypes : undefined;
  let rentalPropertyTypes = Stdlib_Array.filterMap(params.getAll("rentalPropertyTypes"), v => {
    switch (v) {
      case "CONDO" :
        return "CONDO";
      case "SINGLE_FAMILY" :
        return "SINGLE_FAMILY";
      default:
        return;
    }
  });
  let rentalPropertyTypes$1 = rentalPropertyTypes.length !== 0 ? rentalPropertyTypes : undefined;
  let withdrawnOrExpired = QueryParamUtils.bool(params, "withdrawnOrExpired");
  let soldOrRented = QueryParamUtils.bool(params, "soldOrRented");
  let underContract = QueryParamUtils.bool(params, "underContract");
  let keywords = QueryParamUtils.stringArrNonEmpty(params, "keywords");
  let offMlsOnly = QueryParamUtils.bool(params, "offMlsOnly");
  let after = QueryParamUtils.string(params, "after");
  let before = Stdlib_Option.isNone(after) ? QueryParamUtils.string(params, "before") : undefined;
  let active = Stdlib_Option.getOr(QueryParamUtils.bool(params, "active"), true);
  let match = QueryParamUtils.string(params, "view");
  let view;
  if (match !== undefined) {
    switch (match) {
      case "list" :
        view = "List";
        break;
      case "map" :
        view = "Map";
        break;
      default:
        view = undefined;
    }
  } else {
    view = undefined;
  }
  return {
    before: before,
    after: after,
    rentalMode: rentalMode,
    sortOrder: sortOrder,
    areaIds: areaIds,
    maxBeds: maxBeds,
    maxPrice: maxPrice,
    minBeds: minBeds,
    minPrice: minPrice,
    forSalePropertyTypes: forSalePropertyTypes$1,
    rentalPropertyTypes: rentalPropertyTypes$1,
    keywords: keywords,
    offMlsOnly: offMlsOnly,
    active: active,
    soldOrRented: soldOrRented,
    withdrawnOrExpired: withdrawnOrExpired,
    underContract: underContract,
    view: view,
    grouping: QueryParamUtils.bool(params, "grouping"),
    mapViewport: PropertiesSearchMapURL.fromUrl(params)
  };
}

let ParamsFromURL = {
  toParams: toParams,
  fromUrl: fromUrl
};

function sortOrderForApi(useNewPropertiesUpdatedSort, sortOrder) {
  if (!useNewPropertiesUpdatedSort) {
    return sortOrder;
  }
  switch (sortOrder) {
    case "RECENTLY_UPDATED" :
      return "RECENTLY_UPDATED_EXCLUDING_RENEWALS";
    case "RECENTLY_BROADCAST" :
    case "RECENTLY_UPDATED_EXCLUDING_RENEWALS" :
      return sortOrder;
  }
}

function transformParamsForApi(useNewPropertiesUpdatedSortOpt, p) {
  let useNewPropertiesUpdatedSort = useNewPropertiesUpdatedSortOpt !== undefined ? useNewPropertiesUpdatedSortOpt : false;
  let rentalStatuses = [];
  let forSaleStatuses = [];
  if (p.active !== false) {
    rentalStatuses.push("ACTIVE");
    forSaleStatuses.push("ACTIVE");
  }
  if (p.underContract) {
    forSaleStatuses.push("UNDER_CONTRACT");
  }
  if (p.withdrawnOrExpired) {
    forSaleStatuses.push("WITHDRAWN", "EXPIRED");
    rentalStatuses.push("WITHDRAWN", "EXPIRED");
  }
  if (p.soldOrRented) {
    forSaleStatuses.push("SOLD");
    rentalStatuses.push("RENTED");
  }
  let first = Stdlib_Option.isNone(p.before) ? 12 : undefined;
  let last = Stdlib_Option.isSome(p.before) ? 12 : undefined;
  return {
    rentalMode: p.rentalMode,
    after: p.after,
    before: p.before,
    sortOrder: sortOrderForApi(useNewPropertiesUpdatedSort, p.sortOrder),
    areaIds: p.areaIds,
    maxBeds: p.maxBeds,
    maxPrice: p.maxPrice,
    minBeds: p.minBeds,
    minPrice: p.minPrice,
    forSalePropertyTypes: p.forSalePropertyTypes,
    forSaleStatuses: forSaleStatuses,
    rentalPropertyTypes: p.rentalPropertyTypes,
    rentalStatuses: rentalStatuses,
    keywords: p.keywords,
    offMlsOnly: p.offMlsOnly,
    first: first,
    last: last
  };
}

let Params = {
  sortOrderForApi: sortOrderForApi,
  transformParamsForApi: transformParamsForApi
};

function toQueryString(params) {
  let searchParams = new URLSearchParams("");
  let defaultState = getDefaultState();
  if (params.rentalMode) {
    QueryParamUtils.setIfExists(searchParams, "rentalMode", "true", s => s);
  }
  if (params.sortOrder !== defaultState.sortOrder) {
    QueryParamUtils.setIfExists(searchParams, "sortOrder", params.sortOrder, s => s);
  }
  QueryParamUtils.setIfExistsArrStr(searchParams, "areaIds", params.areaIds);
  QueryParamUtils.setIfExistsInt(searchParams, "minPrice", params.minPrice);
  QueryParamUtils.setIfExistsInt(searchParams, "maxPrice", params.maxPrice);
  QueryParamUtils.setIfExistsInt(searchParams, "minBeds", params.minBeds);
  QueryParamUtils.setIfExistsInt(searchParams, "maxBeds", params.maxBeds);
  QueryParamUtils.setIfExistsArr(searchParams, "forSalePropertyTypes", params.forSalePropertyTypes, v => v);
  QueryParamUtils.setIfExistsArr(searchParams, "rentalPropertyTypes", params.rentalPropertyTypes, v => v);
  QueryParamUtils.setIfExistsArrStr(searchParams, "keywords", params.keywords);
  let match = params.offMlsOnly;
  if (match !== undefined && match) {
    QueryParamUtils.setIfExists(searchParams, "offMlsOnly", "true", s => s);
  }
  QueryParamUtils.setIfExists(searchParams, "after", params.after, s => s);
  if (Stdlib_Option.isNone(params.after)) {
    QueryParamUtils.setIfExists(searchParams, "before", params.before, s => s);
  }
  if (!params.active) {
    QueryParamUtils.setIfExistsBool(searchParams, "active", params.active);
  }
  if (params.soldOrRented) {
    QueryParamUtils.setIfExistsBool(searchParams, "soldOrRented", params.soldOrRented);
  }
  if (params.underContract) {
    QueryParamUtils.setIfExistsBool(searchParams, "underContract", params.underContract);
  }
  if (params.withdrawnOrExpired) {
    QueryParamUtils.setIfExistsBool(searchParams, "withdrawnOrExpired", params.withdrawnOrExpired);
  }
  let match$1 = params.view;
  if (match$1 === "List") {
    QueryParamUtils.setIfExists(searchParams, "view", "list", s => s);
  } else {
    QueryParamUtils.setIfExists(searchParams, "view", "map", s => s);
  }
  if (!params.grouping) {
    QueryParamUtils.setIfExistsBool(searchParams, "grouping", false);
  }
  PropertiesSearchMapURL.write(searchParams, params.mapViewport);
  let str = searchParams.toString();
  if (str === "") {
    return "";
  } else {
    return "?" + str;
  }
}

function getCurrentParams() {
  return QueryParamUtils.URLHelpers.getCurrentParams(fromUrl, toParams);
}

function paramsToUrl(params) {
  let location = window.location;
  return location.pathname + toQueryString(params);
}

function setQueryParamsInURL(mode, params) {
  QueryParamUtils.URLHelpers.setQueryParamsInURL(paramsToUrl, toParams, fromUrl, mode, params);
}

function use() {
  return QueryParamUtils.URLHelpers.use(fromUrl, toParams, setQueryParamsInURL);
}

function preserveRelevantParamsWhenSwitchingModes(p) {
  return {
    rentalMode: p.rentalMode,
    sortOrder: p.sortOrder,
    areaIds: p.areaIds,
    maxBeds: p.maxBeds,
    minBeds: p.minBeds,
    keywords: p.keywords,
    offMlsOnly: p.offMlsOnly,
    active: p.active,
    withdrawnOrExpired: p.withdrawnOrExpired,
    underContract: p.underContract,
    soldOrRented: p.soldOrRented,
    view: p.view,
    grouping: p.grouping,
    mapViewport: p.mapViewport
  };
}

exports.getDefaultState = getDefaultState;
exports.hasAreaSelectionChanged = hasAreaSelectionChanged;
exports.ParamsFromURL = ParamsFromURL;
exports.Params = Params;
exports.toQueryString = toQueryString;
exports.getCurrentParams = getCurrentParams;
exports.paramsToUrl = paramsToUrl;
exports.setQueryParamsInURL = setQueryParamsInURL;
exports.use = use;
exports.preserveRelevantParamsWhenSwitchingModes = preserveRelevantParamsWhenSwitchingModes;
/* MediaQuery Not a pure module */
